module.exports = __webpack_public_path__ + "img/wutu.d797d845.png";